import React, { FC } from 'react';
import { useHistory, Link, useLocation } from 'react-router-dom';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { AppData } from '../auth/LogoutManager';

import logo from '../../assets/images/successware.png';

import "../css/Header.css";

const Header: FC = () => {
  const history = useHistory();
  const location = useLocation();
  const [open, setOpen] = React.useState(false);


  const handleClickOpen = () => {
    if (location.pathname === "/admin") {
      AppData.onLogout(history);
    }
    else {
      setOpen(true);
    }
  };

  const handleClose = (logout: boolean) => {
    setOpen(false);
    if (logout) {
      AppData.onLogout(history);
    }
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={() => handleClose(false)}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <span className="logout-warning-text">Are you sure you want to log out? Any unsaved data will be lost.</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-buttons">
          <Button variant="outlined" color="primary" onClick={() => handleClose(false)}>
            No
          </Button>
          <Button variant="outlined" onClick={() => handleClose(true)} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <div className="custom-margin-bottom-header">
        <nav className="bg-white">
          <div className="max-w-6xl mx-auto px-2 sm:px-6 lg:px-8">
            <div className="relative flex items-center justify-between h-16">
              <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                <div className="flex-shrink-0 flex items-center">
                  <Link to="/admin">
                    <img className="block lg:hidden h-8 w-auto"
                      src={logo} alt="Workflow" />
                    <img className="hidden lg:block h-8 w-auto" src={logo} alt="Workflow" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="logout-block">
            <button className="logout-button" onClick={handleClickOpen}><span>Logout</span> <ExitToAppIcon onClick={handleClickOpen} /></button>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Header;